module.exports = __webpack_public_path__ + "static/woman-laughing-square.c8dbfd13.jpg";